import {gql} from '@apollo/client'
export const queryAndroidAppScore=gql`
query AndroidAppScore($app: String!) {
  androidAppScore(app: $app) {
    data {
      date
      score
    }
    latestAt
    latestScore
    total
  }
}
`
export const queryIosAppScore=gql`
query IosAppScore($app: String!) {
  iosAppScore(app: $app) {
    data {
      date
      score
    }
    latestAt
    latestScore
    total
  }
}
`
export const queryAppVersionList=gql`
query Query($app: String!) {
  appVersionList(app: $app)
}
`
export const queryAppReviewsList=gql`
query AppReviewsList($app: String!, $page: Int!, $count: Int!, $version: String, $startDate: Date, $endDate: Date, $platform: AppPlatform) {
  appReviewsList(app: $app, page: $page, count: $count, version: $version, startDate: $startDate, endDate: $endDate, platform: $platform) {
    data {
      appVersion
      content
      createdAt
      region
      replyDate
      replyText
      score
      title
      userName
    }
    total
  }
}
`